export default __webpack_public_path__ + "static/media/snappy.linux-x64-musl.039878b2.node";